'use strict';

var Sugar = require('sugar-core'),
    trim = require('../common/internal/trim'),
    stringEach = require('./internal/stringEach');

Sugar.String.defineInstance({

  'lines': function(str, eachLineFn) {
    return stringEach(trim(str), /^.*$/gm, eachLineFn);
  }

});

module.exports = Sugar.String.lines;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/string/lines.js
// module id = 915
// module chunks = 0